/* eslint-disable max-len */
import { AllieIconProps } from "../../../components";

export const SwitchVerticalIcon: React.FC<AllieIconProps> = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 4V20M7 20L3 16M7 20L11 16M17 20V4M17 4L13 8M17 4L21 8" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
